export default __webpack_public_path__ + "img/eYKJOGtp.16985dd1.svg";